
import { Component, Prop, Vue } from "vue-property-decorator";
import { AttachmentType } from "@/survey";

const initialData = () => {
  return {
    previewReady: false,
    isImage: false
  };
};

@Component({})
export default class FileUploadInput extends Vue {
  @Prop() private id?: string;
  @Prop() private table?: string;
  @Prop() private attachmentType?: AttachmentType;
  @Prop() private mainImage?: boolean;
  @Prop() private imageComment?: string;
  @Prop({ default: false }) private disabled?: boolean;
  @Prop({ default: true }) private allowComment?: boolean;
  apiLocation = Vue.prototype.$apiLocation;
  placeholderImage = "data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20width='90'%20height='90'%20viewBox='0%200%2090%2090'%3E%3Crect%20width='90'%20height='90'%20fill='%23f1f3f5'/%3E%3Cpath%20d='M22%2062l14-16%2010%2010%2011-14%2012%2020H22z'%20fill='%23adb5bd'/%3E%3Ccircle%20cx='32'%20cy='31'%20r='7'%20fill='%23adb5bd'/%3E%3C/svg%3E";

  emitCommentChange() {
    this.$emit("update:imageComment", this.$data.theComment);
  }

  emitMainImageChange() {
    this.$emit("update:mainImage", !this.$data.isMainImage);
  }

  get isMainImage() {
    return this.mainImage;
  }

  // get theComment() {
  //   return this.$props.imageComment;
  // }

  data() {
    return {
      ...initialData(),
      theComment: this.$props.imageComment
    };
  }

  readURL() {
    const input = this.$refs.fileInput as HTMLInputElement;
    if (input.files && input.files[0]) {
      //console.log("File", input.files[0]);
      const type = input.files[0].type;
      this.$emit("update:file", input.files[0]);
      const reader = new FileReader();
      reader.onload = (e: ProgressEvent<FileReader>) => {
        const preview = this.$refs.preview as HTMLImageElement;
        if (e.target !== null) {
          if (typeof e.target.result === "string") {
            if (type.indexOf("image") > -1) {
              preview.src = e.target.result;
              this.$data.isImage = true;
              this.$data.previewReady = true;
            } else {
              preview.src = this.placeholderImage;
              this.$data.isImage = false;
              this.$data.previewReady = false;
            }
          }
        }
      };
      reader.readAsDataURL(input.files[0]);
    }
  }
}
